import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  getallDistrictsChatbot,
  getAllBlocksFromDistrictChatbot,
  getGPFromDistrictAndBlockChatbot,
  getVillageFromGpBlockAndDistrictChatbot,
  getSchoolFromVillageChatbot,
} from "../api/Chatbot";

const ChatBot = (props) => {
  const { t } = useTranslation();
  const chatMessagesRef = useRef(null);
  // const base_url = "https://ohmapi.austere.biz/hostel/api";
  const base_url = "http://localhost:5000/hostel/api";

  const [Alldistricts, setAllDistricts] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);
  const [AllGPs, setAllGPs] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState({
    code: "",
    name: "",
  });
  const [selectedBlock, setSelectedBlock] = useState({ code: "", name: "" });
  const [selectedGP, setSelectedGP] = useState({ code: "", name: "" });
  const [selectedVillage, setSelectedVillage] = useState({
    code: "",
    name: "",
  });
  const [selectedSchool, setSelectedSchool] = useState({ code: "", name: "" });
  const [markRequired, setMarkRequired] = useState(true);
  const [userMessages, setUserMessages] = useState([]);
  const [requirements, setRequirements] = useState("");
  const [step, setStep] = useState(0);

  useEffect(() => {
    const chatboxContainer = document.getElementById("chatbox-container");
    const chatbotButton = document.getElementById("chatbot-button");
    const inputMessage = document.getElementById("inputMessage");
    // const sendMessageButton = document.getElementById("sendMessage");
    const closeChatButton = document.getElementById("closeChat");
    const welcomeMessage = document.querySelector(".outgoingMsg");

    const typingIndicator = document.getElementById("typingIndicator");
    let typingTimeout;

    chatbotButton.addEventListener("click", function () {
      chatboxContainer.classList.toggle("open");
      chatbotButton.style.display = "none";
      hideWelcomeMessage();
      showWelcomeMessage()
      showButtons();
      document.querySelector(".outgoingMsg").style.display = "none";
    });

    closeChatButton.addEventListener("click", function () {
      chatboxContainer.classList.toggle("open");
      chatbotButton.style.display = "flex";
      hideWelcomeMessage();
      showWelcomeMessage();
      showButtons();
      setStep(0);
      setAllSchoolNames([]);
      setAllBlocks([]);
      setAllVillages([]);
      setAllGPs([]);
      setSelectedDistrict({ code: "", name: "" });
      setSelectedBlock({ code: "", name: "" });
      setSelectedGP({ code: "", name: "" });
      setSelectedVillage({ code: "", name: "" });
      setSelectedSchool({ code: "", name: "" });
      setMarkRequired(true);
      setUserMessages([]);
      setRequirements("");
      document.querySelector(".outgoingMsg").style.display = "block";
    });

    function hideWelcomeMessage() {
      if (welcomeMessage) {
        welcomeMessage.style.display = "none";
      }
    }
    let welcomeMessageDisplayed = false;

    function showWelcomeMessage() {
      if (welcomeMessage && !welcomeMessageDisplayed) {
        welcomeMessage.style.display = "block";

        const chatbox = document.getElementById("chat-messages");
        const welcomeMessageDiv = document.createElement("div");
        welcomeMessageDiv.classList.add("message", "bot");
        welcomeMessageDiv.textContent = "Welcome! How can I assist you today?";

        chatbox.insertBefore(welcomeMessageDiv, chatbox.firstChild);

        setTimeout(() => {
          welcomeMessage.style.display = "none";
          showButtons();
        }, 0);

        welcomeMessageDisplayed = true;
      }
    }
    function hideButtons() {
      const buttonsContainer = document.getElementById("buttons-container");
      if (buttonsContainer) {
        buttonsContainer.style.visibility = "hidden";
      }
    }

    function showButtons() {
      const buttonsContainer = document.getElementById("buttons-container");
      if (buttonsContainer) {
        buttonsContainer.style.visibility = "visible";
      }
    }

    getallDistrictsChatbot()
      .then((res) => {
        if (res.status === "success") {
          setAllDistricts(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching districts:", err);
      });
  }, []);

  const handleDistrictChange = (e) => {
    const selectedDistrictCode = e.target.value;
    const selectedDistrictName = e.target.options[e.target.selectedIndex].text;
    setSelectedDistrict({
      code: selectedDistrictCode,
      name: selectedDistrictName,
    });
    getAllBlocksFromDistrictChatbot(selectedDistrictCode)
      .then((res) => {
        if (res.status === "success") {
          setAllBlocks(res.data.new_asset_query);
          setStep(1);
        }
      })
      .catch((err) => {
        console.error("Error fetching blocks:", err);
      });
  };

  const handleBlockChange = (e) => {
    const selectedBlockCode = e.target.value;
    const selectedBlockName = e.target.options[e.target.selectedIndex].text;
    setSelectedBlock({ code: selectedBlockCode, name: selectedBlockName });
    getGPFromDistrictAndBlockChatbot(selectedDistrict.code, selectedBlockCode)
      .then((res) => {
        if (res.status === "success") {
          setAllGPs(res.data.new_asset_query);
          setStep(2);
        }
      })
      .catch((err) => {
        console.error("Error fetching GPs:", err);
      });
  };

  const handleGPChange = (e) => {
    const selectedGPCode = e.target.value;
    const selectedGPName = e.target.options[e.target.selectedIndex].text;
    setSelectedGP({ code: selectedGPCode, name: selectedGPName });
    getVillageFromGpBlockAndDistrictChatbot(
      selectedDistrict.code,
      selectedBlock.code,
      selectedGPCode
    )
      .then((res) => {
        if (res.status === "success") {
          setAllVillages(res.data.new_asset_query);
          setStep(3);
        }
      })
      .catch((err) => {
        console.error("Error fetching villages:", err);
      });
  };

  const handleVillageChange = (e) => {
    const selectedVillageCode = e.target.value;
    const selectedVillageName = e.target.options[e.target.selectedIndex].text;
    setSelectedVillage({
      code: selectedVillageCode,
      name: selectedVillageName,
    });
    getSchoolFromVillageChatbot(selectedVillageCode)
      .then((res) => {
        if (res.status === "success") {
          setAllSchoolNames(res.data.new_asset_query);
          setStep(4);
        }
      })
      .catch((err) => {
        console.error("Error fetching schools:", err);
      });
  };

  const handleSchoolName = (e) => {
    const selectedSchoolCode = e.target.value;
    const selectedSchoolName = e.target.options[e.target.selectedIndex].text;
    setSelectedSchool({ code: selectedSchoolCode, name: selectedSchoolName });
    fetchRequirements(selectedSchoolCode);
  };

  const fetchRequirements = (selectedSchoolCode) => {
    const data = {
      UDISE_code: selectedSchoolCode,
    };
    axios
      .post(
        `${base_url}/get_requirements_chatbot_school_id`,
        data
      )
      .then((res) => {
        const { new_req, pending, completed } =
          res.data.data.new_asset_query[0];
          const requirementsMessage = `New raised requirements: ${new_req}\nPending requirements: ${pending}\nCompleted requirements: ${completed}`;
        setRequirements(requirementsMessage);
        setStep(5);
      })
      .catch((err) => {
        console.error("Error fetching requirements:", err);
      });
  };

  useEffect(() => {
    scrollToBottom();
  }, [userMessages]);

  const scrollToBottom = () => {
    chatMessagesRef.current.scrollIntoView({ behavior: "smooth" });
  };
  

  return (
    <div className="content col-12">
      <div id="chatbox-container">
        <div id="chatbox" className="closed">
          <div className="chat-header">
            <h1>Hey, Ashram!</h1>
            <span id="closeChat" className="close-button">
              close
            </span>
          </div>
          <div id="chat-messages">
            {userMessages.map((message, index) => (
              <div
                key={index}
                className={`message ${index % 1 === 0 ? "user" : "bot"}`}
              >
                {index % 1 === 0 && (
                  <div className="bot-message">{message}</div>
                )}
                {index % 1 !== 0 && (
                  <div className="user-message">{message}</div>
                )}
              </div>
            ))}
            <div ref={chatMessagesRef} />
            <div id="buttons-container">
              {step >= 0 && (
                <>
                  <div className="message bot">Please Select District:</div>
                  <select
                    name="district"
                    className="common-input form-select col-6"
                    onChange={handleDistrictChange}
                    required
                  >
                    <option value="">{t("Select District")}</option>
                    {Alldistricts.map((row, index) => (
                      <option key={index} value={row.district_code}>
                        {row.name}
                      </option>
                    ))}
                  </select>
                  {step >= 1 && (
                    <div className="message user">
                      District: {selectedDistrict.name}
                    </div>
                  )}
                </>
              )}
              {step >= 1 && (
                <>
                  <div className="message bot"> Please Select Block:</div>
                  <select
                    name="block"
                    className="common-input form-select col-6"
                    onChange={handleBlockChange}
                    required
                  >
                    <option value="">{t("Select Block")}</option>
                    {Allblocks.map((row, index) => (
                      <option key={index} value={row.code}>
                        {row.name}
                      </option>
                    ))}
                  </select>
                  {step >= 2 && (
                    <div className="message user">
                      Block: {selectedBlock.name}
                    </div>
                  )}
                </>
              )}
              {step >= 2 && (
                <>
                  <div className="message bot">
                    Please Select Gram Panchayat:
                  </div>
                  <select
                    name="gp"
                    className="common-input form-select col-6"
                    onChange={handleGPChange}
                    required
                  >
                    <option value="">{t("Select Gram Panchayat")}</option>
                    {AllGPs.map((row, index) => (
                      <option key={index} value={row.code}>
                        {row.name}
                      </option>
                    ))}
                  </select>
                  {step >= 3 && (
                    <div className="message user">
                      Gram Panchayat: {selectedGP.name}
                    </div>
                  )}
                </>
              )}
              {step >= 3 && (
                <>
                  <div className="message bot">Please Select Village:</div>
                  <select
                    name="village"
                    className="common-input form-select col-6"
                    onChange={handleVillageChange}
                    required
                  >
                    <option value="">{t("Select Village")}</option>
                    {Allvillages.map((row, index) => (
                      <option key={index} value={row.gm_id}>
                        {row.village_name}
                      </option>
                    ))}
                  </select>
                  {step >= 4 && (
                    <div className="message user">
                      Village: {selectedVillage.name}
                    </div>
                  )}
                </>
              )}
              {step >= 4 && (
                <>
                  <div className="message bot">Please Select School:</div>
                  <select
                    name="schoolName"
                    className="common-input form-select col-6"
                    onChange={handleSchoolName}
                    required
                  >
                    <option value="">{t("Select School")}</option>
                    {AllSchoolNames.map((row, index) => (
                      <option key={index} value={row.code}>
                        {row.name}
                      </option>
                    ))}
                  </select>
                  {step >= 5 && (
                    <>
                      <div className="message user">
                        School: {selectedSchool.name}
                      </div>
                      <div className="message user">{requirements}</div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <div id="typingIndicator" style={{ display: "none" }}>
            <span className="typing-dot"></span>
            <span className="typing-dot"></span>
            <span className="typing-dot"></span>
          </div>
          <div id="userInput">
            {/* <input type="text" id="inputMessage" placeholder="Type your message..." />
            <button id="sendMessage">Send</button> */}
          </div>
        </div>
        <div
          className="col-12 p-2 outgoingMsg"
          style={{ marginLeft: "15px" }}
        >
          <span id="blinkTe">Welcome to Ashram,</span>
          <br />
          <span id="blinkText">I am here to help you!</span>
        </div>
        <div id="chatbot-button" className="closed">
          <img
            src="https://embed.tawk.to/_s/v4/assets/images/attention-grabbers/168-r-br.svg"
            alt="Chat attention grabber"
            id="blinkImage"
            style={{
              width: "100px",
              height: "79px",
              marginRight: "18px",
              marginBottom: "40px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
